import { WEB_URL } from '@/config/endpoints';
import IMAGES from '@/public/assets/img';


export default {
    SeoContent:{
        title: 'Credlix | Plataforma global de financiación de la cadena de suministro para empresas',
        url: WEB_URL+'/es-mx/about-us',
        description:'Infórmese sobre nosotros, Credlix, y qué nos convierte en la plataforma líder mundial de financiación de cadenas de suministro basada en tecnología',
        keyword: '', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    banner:{
    bannerImage:IMAGES.ABOUTIMG.spanishBanner,
    bannerHeadingUnderlineText:'Líder global en tecnología ',
    bannerHeadingText:'para la cadena de suministro',
    bannerParaText:'Hacemos que tu financiamiento sea más seguro, fácil y rápido gracias a nuestro enfoque tencológico y a nuestra experiencia en la cadena de suministro con fabricantes de todo el mundo.',
    },
    section1Head:{
        WWD:'¿Qué hacemos?',
        supplyChain:'Financiar la cadena de suministro completa',
    },

    aboutGlobalEnterprise:'Global Enterprises',
    cities:'Cities',

    section:[
        {para1: 'En Credlix, hemos integrado la experiencia de Moglix transformando de manera integral la cadena de suministro de principio a fin para más de <strong> 700 empresas </strong> y  <strong>16.000 PYMES </strong> que fabrican en India y el Sudeste Asiático, y exportan a más de 53 <strong> países en todo el mundo </strong>, con nuestra tecnología financiera inteligente revolucionando los préstamos de flujo de efectivo.',
        para2:'Fundada en Singapur en 2015, Moglix se ha convertido en una de las empresas de soluciones digitales para la cadena de suministro más grandes y de más rápido crecimiento en Asia, liderando en la adquisición indirecta, gestión de contratos SaaS, almacenamiento y distribución de bienes industriales.',
        image:IMAGES.ABOUTIMG.portship},
        {para1: 'En Credlix, aprovechamos el exclusivo sistema operativo full-stack de Moglix para el comercio B2B, ofreciendo <strong> una solución digital de financiamiento de la cadena </strong> de suministro hecha a la medida, conectando a empresas líderes, proveedores, exportadores y prestamistas, asegurando que el financiamiento de la cadena de suministro y las exportaciones nunca se detengan. ',
        para2:'No solo lideramos con innovación, <strong>transformamos la industria financiera B2B </strong>. Nuestro equipo ejecutivo está al frente de esta revolución, brindando soluciones financieras tecnológicamente avanzadas que impulsan el comercio y la manufactura. Con Credlix, la cadena de suministro se convierte en un motor de oportunidades sin precedentes.',
        image:IMAGES.ABOUTIMG.standinggirl}
    ],


    meetTeam:{
        heading:'Conoce al equipo',
        para:"En Credlix, nuestro equipo de liderazgo ejecutivo aporta una sólida trayectoria en las compañías más destacadas de tecnología, finanzas y manufactura. Esta experiencia es la base para revolucionar cómo compradores, vendedores y exportadores obtienen capital de trabajo, gracias a la automatización financiera que redefine la agilidad empresarial.",
        team:[
            {image:IMAGES.ABOUTIMG.rahulnew,name:'Rahul Garg',designation:'CEO y fundador'},
            {image:IMAGES.ABOUTIMG.rishabhnew,name:'Rishabh Agarwal',designation:'Vicepresidente Sr'},
            {image:IMAGES.ABOUTIMG.sanjeevArora,name:'Sanjeev Arora',designation:'Director financiero'},
            {image:IMAGES.ABOUTIMG.pritamnew,name:'Pramit Joshi',designation:'Director Sr'},
            {image:IMAGES.ABOUTIMG.GenetteNew,name:'Genette Herrera',designation:'Líder México'},
        ]
    },

}
